export async function sendMusic(body) {
  try {
    const response = await fetch('https://api.juangutierreza.com/rj/music', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      cache: 'default',
      body: JSON.stringify(body),
    });

    console.log('response ', response);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
      return { code: response.status, message: 'Error sending music' };
    }

    const data = await response.json();
    return { code: 200, message: data.message };
  } catch (error) {
    return { code: 500, message: 'Internal Server Error' };
  }
}
